module.exports = "<span class='tag'\n    [class.selected]=\"isSelected\"\n    [class.excluded]=\"isExcluded\"\n    (click)='switch($event)'>\n  {{label}}\n  <span class='isExported' *ngIf='isExported'>\n  &euro;\n  </span>\n\n</span>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/tag-filter/tag-filter.component.html
// module id = 442
// module chunks = 0